import React from 'react';
import LoadingCircle from '../Global/LoadingCircle';

const AttendanceCard = ({
  att,
  canManage,
  expandedId,
  toggleExpand,
  handleReopen,
  setDeleteTarget,
  loadingAttendees,
  attendees,
  statusLabels,
  t,
  formatDate,
  formatTime
}) => {
  return (
    <div className="attendanceCard">
      <div
        className="attendanceCardHeader"
        onClick={() => toggleExpand(att.id)}
      >
        <div className="attendanceCardInfo">
          <h3 className="attendanceCardTitle">{att.title}</h3>
          <div className="attendanceCardMeta">
            <span>{formatDate(att.created_at)}, {formatTime(att.created_at)}</span>
            <span className={`attendanceCardBadge ${att.is_active ? "active" : "closed"}`}>
              {att.is_active ? t.badgeActive : t.badgeClosed}
            </span>
          </div>
        </div>

        <div className="attendanceCardStats">
          <span className="attendanceStat validated">
            ✓ {att.attendee_count}
          </span>
          {att.pending_count > 0 && (
            <span className="attendanceStat pending">
              ⏳ {att.pending_count}
            </span>
          )}
        </div>

        {canManage && (
          <div className="attendanceCardActions">
            {!att.is_active && (
              <button
                className="attendanceActionBtn reopen"
                onClick={(e) => {
                  e.stopPropagation();
                  handleReopen(att.id);
                }}
              >
                {t.reopenBtn}
              </button>
            )}
            <button
              className="attendanceActionBtn delete"
              onClick={(e) => {
                e.stopPropagation();
                setDeleteTarget(att.id);
              }}
            >
              {t.deleteBtn}
            </button>
          </div>
        )}

        <span className={`attendanceExpandIcon ${expandedId === att.id ? "expanded" : ""}`}>
          ▾
        </span>
      </div>

      {expandedId === att.id && (
        <div className="attendanceCardBody">
          {loadingAttendees === att.id ? (
            <LoadingCircle />
          ) : attendees[att.id]?.length > 0 ? (
            attendees[att.id].map((person) => (
              <div key={person.id} className="attendeeRow">
                <div className="attendeeInfo">
                  <span className="attendeeName">{person.name}</span>
                  <span className="attendeeEmail">{person.email}</span>
                </div>
                <span className={`attendeeStatus ${person.status}`}>
                  {statusLabels[person.status] || person.status}
                </span>
              </div>
            ))
          ) : (
            <p className="noAttendeesText">{t.noAttendees}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AttendanceCard;
